import { useState, useEffect } from 'react';
import { TimesChart } from '../chart';

export const Timer = ({ timer }) => {
  const [times, setTimes] = useState([]);

  useEffect(() => {
    const times_ = [];

    for (const scope of timer?.scopes || []) {
      const id = times_.push({
        id: `${scope.name}:${scope.depth}:${scope.started}`,
        label: scope.name,
        started: scope.started,
        finished: scope.finished,
        state: scope.finished ? 'completed' : 'active',
      });
    }

    setTimes(times_);
  }, [timer]);

  return (
    <div>
      <TimesChart times={times} labels />
      {/*
      <pre>{JSON.stringify(timer, null, 2)}</pre>
      */}
    </div>
  );
};
